/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Contact_CtaInputs */

const en_directory_resources_contact_cta = /** @type {(inputs: Directory_Resources_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Seek AI`)
};

const zh_directory_resources_contact_cta = /** @type {(inputs: Directory_Resources_Contact_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发送邮件给 Seek AI`)
};

/**
* | output |
* | --- |
* | "Email Seek AI" |
*
* @param {Directory_Resources_Contact_CtaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_contact_cta = /** @type {((inputs?: Directory_Resources_Contact_CtaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Contact_CtaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_contact_cta(inputs)
	return zh_directory_resources_contact_cta(inputs)
});
export { directory_resources_contact_cta as "directory.resources.contact.cta" }